<template>
    <div class="page-complete page">
        <div class="bg">
            <div class="planet">
                <img src="../assets/img/planet.png" alt="">
            </div>
            <div class="tangyuan-01">
                <img src="../assets/img/maked_bg-01.png" alt="">
            </div>
            <div class="tangyuan-02">
                <img src="../assets/img/maked_bg-02.png" alt="">
            </div>
            <div class="star-01">
                <img src="../assets/img/star.png" alt="">
            </div>
            <div class="star-02">
                <img src="../assets/img/star.png" alt="">
            </div>
        </div>
        <div class="hongbao-wrapper">
            <div class="title">
                <img src="../assets/img/make_title.png" alt="">
            </div>
            <div class="hongbao-inner">
                <div class="hongbao-img">
                    <img src="../assets/img/hb.png" alt="">
                </div>
                <div class="hongbao-content">
                    <div class="open-btn" :class="[isOpening && 'opening']" @click="open">
                        <img src="../assets/img/open_btn.png" alt="">
                    </div>
                </div>
            </div>
            <p>点击红包查看封面出价吧！</p>
        </div>
        <div class="bottom">
            <img src="../assets/img/maked_img.png" alt="">
            <img class="bg-top" src="../assets/img/maked_img_top.png" alt="">
            <img class="result-img" :src="resultImg" alt="">
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

@Options ({
    data () {
        return {
            isOpening: false,
            blessings: ['团团圆圆，平安喜乐！', '今夜的月亮，散着团圆的光！', '闹元宵，汤圆吃出幸福新一年！', '月圆心甜，幸幸福福新一年！', '元宵月，愿与你共赏团圆！', '甜蜜汤圆，是节日最好的礼物！', '闹花灯，吃汤圆，和和美美又一年！', '点一盏元宵灯；吃一碗甜汤圆！'],
            resultImg: ''
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'hbData'])
    },
    mounted () {
        this.resultImg = require(`@/assets/img/result_0${Math.floor(Math.random() * 5) + 1}.png`)
        this.$common.track('load', '进入抽奖页')
        this.$common.pageLoaded()
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_RESULTDATA']),
        open () {
            this.$common.track('click', '拆红包')
            // 祝福红包
            if (!this.hbData.amount) {
                this.goResult()
                return
            }
            this.getCash()
        },
        getCash () {
            if (this.isOpening) return
            this.isOpening = true
            this.$request('/lottery/cash', {
                aid: this.aid,
                pid: this.hbData.pid
            }, 'put').then((data: any) => {
                this.isOpening = false
                this.goResult()
            }).catch((res: any) => {
                if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                    this.SET_DIALOGDATA({
                        text: '您的微信未实名认证，不能领取红包，请实名认证后领取',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                    this.$common.toast('加载失败，请重试！')
                }
                this.isOpening = false
            })
        },
        goResult () {
            const resultData = Object.assign(this.hbData, {
                resultImg: this.resultImg
            })
            sessionStorage.setItem('YUANXIAOJIEHONGBAOHBDATA', JSON.stringify(resultData))
            this.SET_RESULTDATA(JSON.parse(JSON.stringify(resultData)))
            this.$router.replace({
                path: '/result'
            })
        }
    }
})
export default class Complete extends Vue {}
</script>

<style lang="scss">
.page-complete {
    position: relative;
    .hongbao-wrapper {
        position: relative;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 1.5rem 0 6.3rem;
        flex-wrap: wrap;
        .title {
            width: 100%;
            margin-bottom: .407407rem;
            font-size: 0;
            line-height: 0;
            text-align: center;
            img {
                width: 3.574074rem;
            }
        }
        .hongbao-inner {
            width: 4.203704rem;
            height: 4.564815rem;
            animation: tada 2s forwards infinite;
            margin: 0 auto;
            text-align: center;
            position: relative;
            .hongbao-img {
                position: absolute;
                left: .388889rem;
                top: 0;
                font-size: 0;
                width: 3.814815rem;
            }
            .hongbao-content {
                padding-top: 1.055556rem;
                width: 100%;
                position: relative;
                z-index: 1;
                font-size: 0;
                line-height: 0;
            }
            .open-btn {
                width: 1.388889rem;
                margin: 0 auto;
                &.opening {
                    animation: openHb ease-in-out 2s infinite;
                }
            }
        }
        p {
            font-family: 'GEhye4gj';
            width: 100%;
            font-size: .407407rem;
            color: #fff;
            text-align: center;
            position: relative;
            line-height: 1.4;
            margin-top: -.555556rem;
            background: url('../assets/img/arrow.png') no-repeat center bottom;
            padding-bottom: .462963rem;
            background-size: 1rem auto;
        }
    }
    .bottom {
        width: 8.916667rem;
        height: 7.175926rem;
        position: absolute;
        left: 53%;
        bottom: -2.151852rem;
        transform: translateX(-50%);
        font-size: 0;
        line-height: 0;
        .bg-top {
            position: absolute;
            left: 0;
            top: 0;
        }
        .result-img {
            position: absolute;
            width: 3.962963rem;
            top: -1.64rem;
            left: 2.05rem;
        }
    }
}

@keyframes openHb {
    0% {
        transform: rotateY(0deg)
    }
    100% {
        transform: rotateY(360deg)
    }
}

@keyframes scale {
    0% {
        transform: scaleY(.2)
    }
    100% {
        transform: scaleY(1)
    }
}

</style>